"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogsResponseFactory = void 0;
var catalogsResponseFactory = function (data) {
    var _a;
    var _source = ((_a = data === null || data === void 0 ? void 0 : data.hits) === null || _a === void 0 ? void 0 : _a.hits[0])._source;
    return {
        id: _source.id,
        parentId: _source.parentId,
        imageUrl: _source.imageUrl,
        label: _source.label,
        companyCode: _source.companyCode,
        nodeTreatments: _source.nodeTreatments,
        treatments: _source.treatments,
    };
};
exports.catalogsResponseFactory = catalogsResponseFactory;
